import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { fr } from "./translations";
import { en } from "./translations";

const LanguageContext = createContext();

const translations = { fr, en };

function detectLanguage() {
  // 1. Check localStorage for user's manual preference
  const saved = localStorage.getItem("advaltis-lang");
  if (saved === "fr" || saved === "en") return saved;

  // 2. Detect from browser language (covers geolocation-based OS settings)
  const browserLang = navigator.language || navigator.languages?.[0] || "en";
  return browserLang.startsWith("fr") ? "fr" : "en";
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(detectLanguage);

  const toggle = useCallback(() => {
    setLang((l) => {
      const next = l === "fr" ? "en" : "fr";
      localStorage.setItem("advaltis-lang", next);
      return next;
    });
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
